module.exports = __webpack_public_path__ + "img/add.728777a4.svg";